import { Fragment } from 'react';
import {
    injectIntl,
    FormattedMessage,
    WrappedComponentProps
} from 'react-intl';
import { connect } from 'react-redux';
import classNames from 'classnames';

import {
    ADD_PHONE_NUMBER,
    CHANGE_PHONE_NUMBER,
    TOGGLE_ADD_PHONE_NUMBER
} from '../../OnfidoVerificationModal.actions';
import styles from './AddPhoneNumberForm.module.css';
import messages from '../../OnfidoVerificationModal.messages';
import { Button } from '@iwoca/orion';
import { Dispatch } from 'redux';
import { TDeserialisedPerson } from '../../OnfidoVerificationModal.types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeNumber: (personUID: string, phoneNumber: string) =>
        dispatch({ type: CHANGE_PHONE_NUMBER, personUID, phoneNumber }),
    addPhoneNumber: (person: TDeserialisedPerson) =>
        dispatch({ type: ADD_PHONE_NUMBER, person }),
    toggleAddPhoneNumber: (personUID: string) =>
        dispatch({ type: TOGGLE_ADD_PHONE_NUMBER, personUID })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const AddPhoneNumberForm = ({
    person,
    intl,
    changeNumber,
    toggleAddPhoneNumber,
    addPhoneNumber
}: { person: TDeserialisedPerson } & PropsFromRedux &
    WrappedComponentProps) => {
    return (
        <>
            {person.error && (
                <span className={styles.error}>
                    <FormattedMessage {...messages.enterValidNumber} />
                </span>
            )}
            <div className={styles.AddPhoneNumberForm}>
                <input
                    data-testid="phoneNumberInput"
                    className={classNames(
                        styles.phoneNumberInput,
                        'fs-exclude'
                    )}
                    placeholder={intl.formatMessage(messages.yourPhoneNumber)}
                    type="text"
                    onChange={(event) =>
                        changeNumber(person.uid, event.target.value)
                    }
                />
                <Button
                    disabled={
                        !person.newPhoneNumber || person.addPhoneNumberPending
                    }
                    onClick={() => addPhoneNumber(person)}
                    className={styles.saveNumber}
                >
                    <FormattedMessage {...messages.save} />
                </Button>
                <button
                    className={styles.cancelNumber}
                    onClick={() => toggleAddPhoneNumber(person.uid)}
                >
                    <FormattedMessage {...messages.cancel} />
                </button>
            </div>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    null,
    mapDispatchToProps
)(injectIntl(AddPhoneNumberForm));
